import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { translationProvider, TRANSLATION_SCOPE } from './assets/i18n/translation.provider';
import { CompanyPaymentSettingsFacade } from '@rx-applications/company-payment/data-access';
import { SetupIntentResult } from '@stripe/stripe-js';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContentComponent, RxAlertModule } from '@roomex/rx-components';
import { PaymentElementComponent } from '@rx-applications/company-payment/ui';
import { TranslocoModule } from '@ngneat/transloco';


@Component({
  selector: 'rx-applications-feature-add-payment-method',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './feature-add-payment-method.component.html',
  styleUrls: ['./feature-add-payment-method.component.scss'],
  providers: [translationProvider],
  imports: [CommonModule, TranslocoModule, RxAlertModule, PaymentElementComponent, ModalContentComponent],
})
export class FeatureAddPaymentMethodComponent {
  @Input() clientSecret: string;

  companySettingsFacade = inject(CompanyPaymentSettingsFacade);
  #activeModal = inject(NgbActiveModal);
  readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  onSavedSetupIntent(event: SetupIntentResult): void {
    this.companySettingsFacade.confirmSetupIntent(event);
  }

  onLoadingError(): void {
    this.#activeModal.close();
    this.companySettingsFacade.loadingError();
  }
}
